import { render, staticRenderFns } from "./SchemaTable.vue?vue&type=template&id=14fb10cc&scoped=true&"
import script from "./SchemaTable.vue?vue&type=script&lang=js&"
export * from "./SchemaTable.vue?vue&type=script&lang=js&"
import style0 from "./SchemaTable.vue?vue&type=style&index=0&id=14fb10cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fb10cc",
  null
  
)

component.options.__file = "SchemaTable.vue"
export default component.exports